module.exports = [
  'adminModule',
  'authModule',
  'gameModule',
  'questionModule',
  'userModule',
  'uploadModule',
  'settingModule',
  'categoryModule',
  'backupModule',
  'cluodinaryModule',
  'metaDataModule',
  'questionRepositoryModule',
  'creditModule',
]
